import React, { useState } from "react";

// Failure belongs to the URL, so changing a slide or replacing a photo can recover.
export default function PharmacyImage({ src, fallback = null, ...props }) {
  const [failedSource, setFailedSource] = useState(null);
  if (!src || failedSource === src) return fallback;
  return <img {...props} src={src} onError={() => setFailedSource(src)} />;
}
